import React from "react";


const Banner = ({therebelivedata}) => {
 
    const textsone = therebelivedata.textsone;
    const textstwo = therebelivedata.textstwo;
    const imgs = therebelivedata.imgs;
  return (
   <section className="what-believe-section">
       <div className="container">
           <div className="believe-content-wrapper d-flex">
               <div className="believe-content">
                   <h2>{therebelivedata.titleone}</h2>
                   <h3>{therebelivedata.titletwo}</h3>
                   <div className="moto-content">
                   {textsone.map((text,index) => (
                       <p key={index}>{text.title}</p>
                   ))}
                       
                   </div>
                   <div className="main-content">
                   {textstwo.map((text,index) => (
                        <div>{Array.isArray(text.title) && text.title.length > 0? <div><h3>{text.title[0]}</h3><p key={index}>{text.title[1]}</p></div> : <p key={index}>{text.title}</p>}</div>
                   ))}
                   </div>
               </div>
               <div className="believe-image">
               {imgs.map((img,index) => (
                    <img key={index} src={img.img} alt={img.alt} className={img.class}/>
               ))}
                   <h4 className="fade-img">{therebelivedata.textthree}</h4>
               </div>
           </div>
       </div>
   </section>
  );
};

export default Banner;